export default {
  checkInterval: 'controleerInterval',
  newCommitCheckInterval: 'Nieuwe commit controleerinterval',
  schedule: 'Schema',
  newSchedule: 'Nieuw schema',
  deleteSchedule: 'Schema verwijderen',
  editSchedule: 'Schema bewerken',
  backup: 'Project back-up',
  downloadTheProjectBackupFile: 'Download het project back-up bestand (in json)',
  restoreProject: 'Project herstellen...',
  incorrectUsrPwd: 'Onjuiste inlog of wachtwoord',
  askDeleteUser: 'Wilt u deze gebruiker echt verwijderen?',
  askDeleteTemp: 'Wilt u deze sjabloon echt verwijderen?',
  askDeleteEnv: 'Wilt u deze omgeving echt verwijderen?',
  askDeleteInv: 'Wilt u deze uitvinder echt verwijderen?',
  askDeleteKey: 'Wilt u deze sleutel echt verwijderen?',
  askDeleteRepo: 'Wilt u deze repository echt verwijderen?',
  askDeleteProj: 'Wilt u dit project echt verwijderen?',
  askDeleteTMem: 'Wilt u dit teamlid echt verwijderen?',
  askDeleteSchedule: 'Wilt u dit schema echt verwijderen?',
  edit: 'Bewerken',
  nnew: 'Nieuw',
  keyFormSshKey: 'SSH-sleutel',
  keyFormLoginPassword: 'Inloggen met wachtwoord',
  keyFormNone: 'Geen',
  incorrectUrl: 'Onjuiste URL',
  username: 'Gebruikersnaam',
  username_required: 'Gebruikersnaam is vereist',
  dashboard: 'Dashboard',
  history: 'Geschiedenis',
  activity: 'Activiteit',
  settings: 'Instellingen',
  signIn: 'Inloggen',
  password: 'Wachtwoord',
  changePassword: 'Wachtwoord wijzigen',
  editUser: 'Gebruiker bewerken',
  newProject: 'Nieuw project',
  close: 'Sluiten',
  newProject2: 'Nieuw project...',
  demoMode: 'DEMO MODUS',
  task: 'Taak #{expr}',
  youCanRunAnyTasks: 'U kunt elke taak uitvoeren',
  youHaveReadonlyAccess: 'U heeft alleen-lezen toegang',
  taskTemplates: 'Taak sjablonen',
  inventory: 'Inventaris',
  environment: 'Omgevingsvariabelen',
  keyStore: 'Sleutelopslag',
  repositories: 'Repositories',
  darkMode: 'Donkere modus',
  team: 'Team',
  users: 'Gebruikers',
  editAccount: 'Account bewerken',
  signOut: 'Uitloggen',
  error: 'Fout',
  refreshPage: 'Vernieuw pagina',
  relogin: 'Opnieuw inloggen',
  howToFixSigninIssues: 'Hoe inlogproblemen op te lossen',
  firstlyYouNeedAccessToTheServerWhereSemaphoreRunni: 'Ten eerste heeft u toegang nodig tot de server waar Semaphore draait.',
  executeTheFollowingCommandOnTheServerToSeeExisting: 'Voer de volgende opdracht op de server uit om bestaande gebruikers te zien:',
  semaphoreUserList: 'semaphore gebruikerslijst',
  youCanChangePasswordOfExistingUser: 'U kunt het wachtwoord van een bestaande gebruiker wijzigen:',
  semaphoreUserChangebyloginLoginUser123Password: 'semaphore gebruiker wijzig-per-inlog --login user123 --wachtwoord {maakWachtwoordVoorbeeld}',
  orCreateNewAdminUser: 'Of maak een nieuwe admin gebruiker:',
  close2: 'Sluiten',
  semaphore: 'SEMAPHORE',
  dontHaveAccountOrCantSignIn: 'Heeft u geen account of kunt u niet inloggen?',
  password2: 'Wachtwoord',
  cancel: 'Annuleren',
  noViews: 'Geen weergaven',
  addView: 'Weergave toevoegen',
  editEnvironment: 'Omgeving bewerken',
  deleteEnvironment: 'Omgeving verwijderen',
  newEnvironment: 'Nieuwe omgeving',
  environmentName: 'Omgevingsnaam',
  extraVariables: 'Extra variabelen',
  enterExtraVariablesJson: 'Voer extra variabelen JSON in...',
  environmentVariables: 'Omgevingsvariabelen',
  enterEnvJson: 'Voer env JSON in...',
  environmentAndExtraVariablesMustBeValidJsonExample: 'Omgeving en extra variabelen moeten geldige JSON zijn. Voorbeeld:',
  dashboard2: 'Dashboard',
  ansibleSemaphore: 'Semaphore UI',
  wereSorryButHtmlwebpackpluginoptionstitleDoesntWor: 'Het spijt ons, maar <%= htmlWebpackPlugin.options.title %> werkt niet goed zonder ingeschakelde JavaScript. Schakel het in om door te gaan.',
  deleteInventory: 'Inventaris verwijderen',
  newInventory: 'Nieuwe inventaris',
  name: 'Naam',
  userCredentials: 'Gebruikersreferenties',
  sudoCredentialsOptional: 'Sudo-referenties (optioneel)',
  type: 'Type',
  pathToInventoryFile: 'Pad naar inventarisbestand',
  enterInventory: 'Voer inventaris in...',
  staticInventoryExample: 'Statische inventarisvoorbeeld:',
  staticYamlInventoryExample: 'Statische YAML-inventarisvoorbeeld:',
  keyName: 'Sleutelnaam',
  loginOptional: 'Inloggen (optioneel)',
  usernameOptional: 'Gebruikersnaam (optioneel)',
  privateKey: 'Privésleutel',
  override: 'Overschrijven',
  useThisTypeOfKeyForHttpsRepositoriesAndForPlaybook: 'Gebruik dit type sleutel voor HTTPS-repositories en voor playbooks die geen SSH-verbindingen gebruiken.',
  deleteKey: 'Sleutel verwijderen',
  newKey: 'Nieuwe sleutel',
  create: 'Aanmaken',
  newTask: 'Nieuwe taak',
  cantDeleteThe: 'Kan de {objectTitle} niet verwijderen',
  theCantBeDeletedBecauseItUsedByTheResourcesBelow: 'De {objectTitle} kan niet worden verwijderd omdat deze wordt gebruikt door de onderstaande bronnen',
  projectName: 'Projectnaam',
  allowAlertsForThisProject: 'Sta waarschuwingen voor dit project toe',
  telegramChatIdOptional: 'Telegram Chat ID (optioneel)',
  maxNumberOfParallelTasksOptional: 'Maximaal aantal parallelle taken (optioneel)',
  deleteRepository: 'Repository verwijderen',
  newRepository: 'Nieuwe repository',
  urlOrPath: 'URL of pad',
  absPath: 'absoluut pad',
  branch: 'Tak',
  accessKey: 'Toegangssleutel',
  credentialsToAccessToTheGitRepositoryItShouldBe: 'Referenties om toegang te krijgen tot de Git-repository. Het zou moeten zijn:',
  ifYouUseGitOrSshUrl: 'als u Git- of SSH-URL gebruikt.',
  ifYouUseHttpsOrFileUrl: 'als u HTTPS- of bestand-URL gebruikt.',
  none: 'Geen',
  ssh: 'SSH',
  deleteProject: 'Project verwijderen',
  save: 'Opslaan',
  deleteProject2: 'Project verwijderen',
  onceYouDeleteAProjectThereIsNoGoingBackPleaseBeCer: 'Zodra u een project verwijdert, is er geen weg meer terug. Wees zeker.',
  name2: 'Naam *',
  title: 'Titel *',
  description: 'Beschrijving',
  required: 'Vereist',
  key: '{expr}',
  surveyVariables: 'Enquêtevariabelen',
  addVariable: 'Variabele toevoegen',
  vaultName: 'Kluis ID (naam)',
  vaultNameDefault: 'Er mag maar één `default` (lege) naam bestaan',
  vaultNameUnique: 'Moet uniek zijn',
  vaults: 'Kluis',
  vaultAdd: 'Kluis toevoegen',
  vaultRequired: 'Kluiswachtwoord is vereist',
  columns: 'Kolommen',
  buildVersion: 'Bouwversie',
  messageOptional: 'Bericht (optioneel)',
  debug: 'Debuggen',
  dryRun: 'Droog draaien',
  diff: 'Verschil',
  advanced: 'Geavanceerd',
  hide: 'Verbergen',
  pleaseAllowOverridingCliArgumentInTaskTemplateSett: 'Om het overschrijven van CLI-argumenten in Taak Sjablooninstellingen toe te staan',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe: 'CLI-argumenten (JSON-array). Voorbeeld: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  started: 'Gestart',
  author: 'Auteur',
  duration: 'Duur',
  stop: 'Stoppen',
  forceStop: 'Forceer stoppen',
  confirmTask: 'Bevestigen',
  deleteTeamMember: 'Teamlid verwijderen',
  team2: 'Team',
  newTeamMember: 'Nieuw teamlid',
  user: 'Gebruiker',
  administrator: 'Administrator',
  definesStartVersionOfYourArtifactEachRunIncrements: 'Definieert de startversie van uw artifact. Elke uitvoering verhoogt de artifactversie.',
  forMoreInformationAboutBuildingSeeThe: 'Voor meer informatie over bouwen, zie de',
  taskTemplateReference: 'Taak sjabloonreferentie',
  definesWhatArtifactShouldBeDeployedWhenTheTaskRun: 'Definieert welk artifact moet worden gedeployed wanneer de taak draait.',
  forMoreInformationAboutDeployingSeeThe: 'Voor meer informatie over implementeren, zie de',
  taskTemplateReference2: 'Taak sjabloonreferentie',
  definesAutorunSchedule: 'Definieert autorun-schema.',
  forMoreInformationAboutCronSeeThe: 'Voor meer informatie over cron, zie de',
  cronExpressionFormatReference: 'Cron-expressieformaatreferentie',
  startVersion: 'Startversie',
  example000: 'Voorbeeld: 0.0.0',
  buildTemplate: 'Bouwsjabloon',
  autorun: 'Automatisch uitvoeren',
  playbookFilename: 'Playbook-bestandsnaam *',
  exampleSiteyml: 'Voorbeeld: deploy/site.yml',
  inventory2: 'Inventaris *',
  repository: 'Repository',
  environment3: 'Omgeving *',
  vaultPassword: 'Kluiswachtwoord',
  vaultPassword2: 'Kluiswachtwoord',
  view: 'Weergave',
  cron: 'Cron',
  iWantToRunATaskByTheCronOnlyForForNewCommitsOfSome: 'Ik wil een taak via cron alleen uitvoeren voor nieuwe commits van een bepaalde repository',
  repository2: 'Repository',
  cronChecksNewCommitBeforeRun: 'Cron controleert nieuwe commit voordat deze wordt uitgevoerd',
  readThe: 'Lees de',
  toLearnMoreAboutCron: 'om meer te leren over Cron.',
  suppressSuccessAlerts: 'Suppress success alerts',
  cliArgsJsonArrayExampleIMyinventoryshPrivatekeythe2: 'CLI-argumenten (JSON-array). Voorbeeld: [ "-i", "@myinventory.sh", "--private-key=/there/id_rsa", "-vvvv" ]',
  allowCliArgsInTask: 'Sta CLI-argumenten toe in Taak',
  docs: 'documentatie',
  editViews: 'Weergaven bewerken',
  newTemplate: 'Nieuw sjabloon',
  taskTemplates2: 'Taak sjablonen',
  all: 'Alle',
  notLaunched: 'Niet gelanceerd',
  by: 'door {user_name}',
  editTemplate: 'Sjabloon bewerken',
  newTemplate2: 'Nieuw sjabloon',
  deleteTemplate: 'Sjabloon verwijderen',
  playbook: 'Playbook',
  email: 'E-mail',
  adminUser: 'Admin gebruiker',
  sendAlerts: 'Waarschuwingen verzenden',
  deleteUser: 'Verwijder gebruiker',
  newUser: 'Nieuwe gebruiker',
  re: 'Re{getActionButtonTitle}',
  teamMember: '{expr} teamlid',
  taskId: 'Taak ID',
  version: 'Versie',
  status: 'Status',
  start: 'Start',
  actions: 'Acties',
  alert: 'Waarschuwing',
  admin: 'Admin',
  role: 'Rol',
  external: 'Extern',
  time: 'Tijd',
  path: 'Pad',
  gitUrl: 'Git URL',
  sshKey: 'SSH-sleutel',
  lastTask: 'Laatste taak',
  task2: 'Taak',
  build: 'Bouwen',
  deploy: 'Implementeren',
  run: 'Uitvoeren',
  add: 'Toevoegen',
  password_required: 'Wachtwoord is vereist',
  name_required: 'Naam is vereist',
  user_credentials_required: 'Gebruikersreferenties zijn vereist',
  type_required: 'Type is vereist',
  path_required: 'Pad naar inventarisbestand is vereist',
  private_key_required: 'Privésleutel is vereist',
  project_name_required: 'Projectnaam is vereist',
  repository_required: 'Repository is vereist',
  branch_required: 'Tak is vereist',
  key_required: 'Sleutel is vereist',
  user_required: 'Gebruiker is vereist',
  build_version_required: 'Bouwversie is vereist',
  title_required: 'Titel is vereist',
  isRequired: 'is vereist',
  mustBeInteger: 'Moet een geheel getal zijn',
  mustBe0OrGreater: 'Moet 0 of groter zijn',
  start_version_required: 'Startversie is vereist',
  playbook_filename_required: 'Playbook-bestandsnaam is vereist',
  inventory_required: 'Inventaris is vereist',
  environment_required: 'Omgeving is vereist',
  email_required: 'E-mail is vereist',
  build_template_required: 'Bouwsjabloon is vereist',
  Task: 'Taak',
  Build: 'Bouwen',
  Deploy: 'Implementeren',
  Run: 'Uitvoeren',
  ReBuild: 'Herbouwen',
  ReDeploy: 'Herimplementeren',
  ReRun: 'Heruitvoeren',
  CreateDemoProject: 'Maak demo-project',
  LeaveProject: 'Verlaat project',
  integration: 'Integratie',
  integrations: 'Integraties',
  NewIntegration: 'Nieuwe integratie',
  EditIntegration: 'Integratie bewerken',
  DeleteIntegration: 'Integratie verwijderen',
  DeleteIntegrationMsg: 'Weet u zeker dat u deze integratie wilt verwijderen?',
  AddAlias: 'Alias toevoegen',
  LoadAlias: 'Aliassen laden...',
  globalAlias: 'Beschikbaar per project en globale alias',
  matcher: 'Matcher',
  matchType: 'Vergelijkingsmethode',
  newMatcher: 'Nieuwe matcher',
  matchMethod: 'Vergelijkingsmethode',
  matchBodyDataType: 'Body-gegevens type',
  extractValue: 'Waarde extraheren',
  newExtractedValue: 'Nieuwe geëxtraheerde waarde',
  extractedValueSource: 'Waarde bron',
  matchKey: 'Sleutel',
  matchValue: 'Waarde',
  matchOn: 'Vergelijk op',
  runners: 'Runners',
  newRunner: 'Nieuwe runner',
  enabled: 'Ingeschakeld',
  scheduleNextRun: 'Volgende uitvoering',
  maxNumberOfParallelTasks: 'Maximaal aantal parallelle taken',
  runnerUsage: 'Gebruik:',
  runnerToken: 'Token:',
  editRunner: 'Runner bewerken',
  deleteRunner: 'Runner verwijderen',
  askDeleteRunner: 'Wilt u runner {runner} echt verwijderen?',
  projectRestoreResult: 'Projectherstelresultaten',
  projectWithNameRestored: 'Project {projectName} succesvol hersteld.',
  pleaseUpdateAccessKeys: 'Werk ze bij voordat u taken uitvoert.',
  emptyKeysRestored: '{emptyKeys} lege sleutels toegevoegd.',
  template: 'Sjabloon',
  aliasUrlCopied: 'De alias-URL is naar het klembord gekopieerd.',
  yes: 'Ja',
  activeTasks: 'Actieve taken',
  taskLocation: 'Locatie',
  empty: 'Leeg',
  noValues: 'Geen waarden',
};
